import axios from 'axios'

const env = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {}
// Dev: talk to the local backend. Prod: same-origin (nginx proxies /api to the backend).
const isLocalDev = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)
export const API_BASE = env.VITE_API_URL || (isLocalDev ? 'http://localhost:5001' : '')

const TOKEN_KEY = 'cs_token'
const USER_KEY = 'cs_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY)) || null
  } catch (e) {
    return null
  }
}

export function isAuthenticated() {
  return Boolean(getToken())
}

function setSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
  applyGlobalAuthHeader()
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  delete axios.defaults.headers.common.Authorization
}

// Covers components that use the shared axios singleton (e.g. PromptEditor)
export function applyGlobalAuthHeader() {
  const token = getToken()
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  }
}

export async function login(email, password) {
  const { data } = await axios.post(`${API_BASE}/api/auth/login`, { email, password })
  setSession(data.token, data.user)
  return data.user
}

export async function register(name, email, password) {
  const { data } = await axios.post(`${API_BASE}/api/auth/register`, { name, email, password })
  setSession(data.token, data.user)
  return data.user
}

export function logout() {
  clearSession()
}

// Append the token to URLs opened via window.open (headers can't ride along)
export function withToken(url) {
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}token=${encodeURIComponent(getToken())}`
}
